// Shared inactivity state for the session timeout. Stored in localStorage
// so every open tab sees the same "last real activity" time.
const ACTIVITY_KEY = "cpg.session.lastActivity";
const LOGOUT_KEY = "cpg.session.logout";
export const IDLE_TIMEOUT_MS = 60 * 60 * 1000;
const WRITE_THROTTLE_MS = 5000;

let memLast = 0;

// localStorage is the source of truth (shared by all tabs); the in-memory
// copy is only used when storage is unavailable (e.g. blocked).
export function getLastActivity() {
  try {
    const raw = window.localStorage.getItem(ACTIVITY_KEY);
    return raw === null ? memLast : Number(raw) || 0;
  } catch {
    return memLast;
  }
}

export function markActivity(force = false) {
  const now = Date.now();
  if (!force && now - getLastActivity() < WRITE_THROTTLE_MS) return;
  memLast = now;
  try { window.localStorage.setItem(ACTIVITY_KEY, String(now)); } catch { /* private mode */ }
}

export function isIdleExpired() {
  const last = getLastActivity();
  return last > 0 && Date.now() - last >= IDLE_TIMEOUT_MS;
}

export function broadcastLogout(reason) {
  try { window.localStorage.setItem(LOGOUT_KEY, JSON.stringify({ at: Date.now(), reason })); } catch { /* ignore */ }
}

export function parseLogoutBroadcast(e) {
  if (e.key !== LOGOUT_KEY || !e.newValue) return null;
  try { return JSON.parse(e.newValue); } catch { return { reason: "logout" }; }
}

export function clearSessionActivity() {
  memLast = 0;
  try { window.localStorage.removeItem(ACTIVITY_KEY); } catch { /* ignore */ }
}
